import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import { ListLabel } from "../LogDetail";
import { ModelResultProps } from "../../../../config/modelsConfig";
import { QwenResult } from "../../../../models/log";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    models: {
      [theme.breakpoints.down(430)]: {
        fontSize: "4vw",
        display: "grid",
      },
    },
  }),
);

export const QwenDetails: React.FC<ModelResultProps> = (props) => {
  const modelResult = props.modelResult as QwenResult;
  const classes = useStyles(props);

  return (
    <>
      <ListItem className={classes.models}>
        <ListLabel title={"Answer"} value={modelResult.answer ? "True" : "False"} />
      </ListItem>
      <Divider />
      <ListItem className={classes.models}>
        <ListLabel title={"Thoughts"} value={modelResult.thoughts} />
      </ListItem>
      <Divider />
      <ListItem className={classes.models}>
        <ListLabel title={"Max new tokens"} value={`${modelResult.maxNewTokens}`} />
      </ListItem>
      <Divider />
      <ListItem className={classes.models}>
        <ListLabel title={"Input Expert Score"} value={`${modelResult.inputExpertScore}`} />
      </ListItem>
      <Divider />
      <ListItem className={classes.models}>
        <ListLabel title={"Raw Output"} value={modelResult.rawOutput} />
      </ListItem>
      <ListItem className={classes.models}>
        <ListLabel title={"Elapsed Time"} value={`${modelResult.elapsedTime}`} />
      </ListItem>
      <Divider />
    </>
  );
};
